import apiClient from './apiClient';

// Διαχείριση ανακλητών κλειδιών πρόσβασης (ΜΛΑ-08).
//
// **Δικό του module** και όχι νέες μέθοδοι στο `auth.service.js`: εκείνο ανήκει σε
// άλλον κλάδο κατά τον κανόνα ιδιοκτησίας, και νέο αρχείο δεν συγκρούεται ποτέ.
//
// Το μυστικό επιστρέφεται **μόνο** από τη `create`, στο πεδίο `key`. Καμία άλλη
// κλήση δεν το φέρνει, γιατί ο εξυπηρετητής δεν το κρατά: στη βάση ζει μόνο το
// αποτύπωμά του.

/** ΛΑ-26 / ΜΛΑ-08: ο κατάλογος, με τα ανακλημένα ορατά και σημασμένα. */
export function getApiKeys({ page = 1 } = {}) {
    return apiClient.getPage(`/api/api-keys?page=${page}`);
}

/** Οι συλλογές του χρήστη, για την επιλογή εύρους κατά τη δημιουργία. */
export function getCollections() {
    return apiClient.getPage('/api/collections?limit=100');
}

/**
 * Δημιουργία. Η απόκριση φέρει το μυστικό **μία φορά**.
 *
 * Το `collection` είναι υποχρεωτικό: το κλειδί δένεται σε μία συλλογή, ώστε το
 * εύρος του να μην είναι σιωπηλή συνάρτηση των συμμετοχών του δημιουργού.
 */
export function createApiKey({ label, collection }) {
    return apiClient.post('/api/api-keys', { label, collection });
}

/**
 * Ανάκληση. Το έγγραφο **μένει**· η πρόσβαση σταματά αμέσως.
 *
 * `POST /revoke` και όχι `DELETE` (D24): η ανάκληση είναι μεταβολή κατάστασης, και
 * από τη στιγμή που υπάρχει και πραγματική διαγραφή οι δύο ενέργειες δεν μπορούν να
 * μοιράζονται ρήμα.
 */
export function revokeApiKey(id) {
    return apiClient.post(`/api/api-keys/${id}/revoke`);
}

/**
 * Οριστική διαγραφή **ανακλημένου** κλειδιού. Ο εξυπηρετητής απαντά 409 σε ενεργό:
 * ο θάνατος του διαπιστευτηρίου καταγράφεται πάντοτε, και η διαγραφή είναι δεύτερο
 * βήμα. Το `lastUsedAt` περνά στο ίχνος πριν φύγει το έγγραφο.
 */
export function deleteApiKey(id) {
    return apiClient.del(`/api/api-keys/${id}`);
}

export default { getApiKeys, getCollections, createApiKey, revokeApiKey, deleteApiKey };
